const getDefaultBranchState = () => {
  return {
    allBranches: [],
  }
}

export default getDefaultBranchState()
export { getDefaultBranchState }
